export type MSTheme = 'default' | 'dark' | 'contrast'

export enum GoToAppTheme {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system',
}
